module.exports = __webpack_public_path__ + "files/fee9721a6305a49662a40ffd052a7965.json";


//////////////////
// WEBPACK FOOTER
// ./config/manifest.json
// module id = 706
// module chunks = 60